export const areaToPosition = (area: Area) => {
  const { from } = area;
  const { x, y } = from;

  const nx = x - 2.5;
  const nz = y - 2.5;

  return [nx, 0, nz];
};
